import { gql } from "@apollo/client";
import TrackFragment from "@urp/wagerpad/src/graphql/fragments/TrackFragment";

export const GET_TRACKS_LIST = gql`
  query getTracks(
    $wagerProfile: String
    $sortByName: TrackListSort
    $trackFilters: TrackListFilter
    $product: String
    $brand: String
  ) {
    tracks(profile: $wagerProfile, sort: $sortByName, filter: $trackFilters) {
      ...Track
    }
  }
  ${TrackFragment.entry}
`;
